module.exports = __webpack_public_path__ + "img/transform.e3682c82.svg";